// L'avis sur une offre, en tête de la fiche Radar (issue #169).
//
// La fiche disait trois fois le même avis : l'anneau et « Bon match », puis
// cinq barres avec cinq légendes, puis atouts et écarts en puces, où les
// écarts se répétaient (« Gradle ou Maven et Java 17+ ne sont pas précisés »,
// puis « Gradle ou Maven », puis « Java 17+ »). Ici, UNE lecture : le score
// et son palier, ce qu'un CV adapté en ferait, une ligne « Pour vous » et une
// ligne « À vérifier ». Le détail (dimensions, écarts) reste à un clic, dans
// le panneau replié sous l'action.

import { useState } from 'react'
import { ScoreRing, scoreTone, type ScoreLabels } from '@ai-job-fit/ui'
import { premiereVueDuScore } from '../lib/mouvement'
import type { CompatibilityResult } from '@ai-job-fit/engine/scoring'
import { useT } from '../lib/i18n'
import { aVerifier } from '../lib/avis'

export function AvisOffre({
  result,
  labels,
  feedback,
  onFeedback,
  offreId,
}: {
  result: CompatibilityResult
  /** L'offre : son score monte la première fois qu'on la voit (#183). Absent, rien ne bouge. */
  offreId?: number
  labels: ScoreLabels
  feedback: 'up' | 'down' | null
  onFeedback: (positive: boolean) => void
}) {
  const t = useT()
  const [anime] = useState(() => offreId !== undefined && premiereVueDuScore(offreId))
  const ton = scoreTone(result.score)
  const gain = (result.potentialScore ?? 0) - result.score
  const pour = (result.matchedKeywords ?? []).slice(0, 3).map((x) => String(x).trim().replace(/[.;,\s]+$/, '')).filter(Boolean)
  const doute = aVerifier(result)
  return (
    <section className="avis-offre" data-testid="avis-offre">
      <div className="avis-tete">
        <ScoreRing score={result.score} tone={ton} size={64} anime={anime} />
        <div>
          <b className={`avis-palier ${ton}`}>{labels.tone[ton]}</b>
          {gain > 0 && <span className="avis-adapte">{t('offre.avisAdapte', { n: result.potentialScore })}</span>}
        </div>
      </div>
      {(pour.length > 0 || doute) && (
        <dl className="avis-lignes">
          {pour.length > 0 && (
            <div>
              <dt className="pour">{t('offre.avisPour')}</dt>
              <dd>{pour.join(', ')}.</dd>
            </div>
          )}
          {doute && (
            <div>
              <dt className="averif">{t('offre.avisAVerifier')}</dt>
              <dd>{doute}.</dd>
            </div>
          )}
        </dl>
      )}
      <div className="score-avis-lien">
        {feedback === 'down' ? (
          <span>{t('offre.avisFauxMerci')}</span>
        ) : (
          <button type="button" className="linkish" onClick={() => onFeedback(false)}>{t('offre.avisFaux')}</button>
        )}
      </div>
    </section>
  )
}
